import React, { useState } from "react";
import styles from "../../Home/CommissionCalculation/CommissionCalculation.module.css";
import axios from "./../../../axios/index";
import Modal from "react-bootstrap/Modal";
import { removeCommas } from "@persian-tools/persian-tools";
import PersianNumberToString from "persian-number-tostring";
import { ToastContainer, toast } from "react-toastify";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";

export default function ConsultantCommissionCalculateModal(props) {
  const [commissionData, setCommissionData] = useState({
    sellOrRent: "sell",
    sellPrice: "",
    rentPrice: "",
    mortgagePrice: "",
    commissionPrice: "",
    commissionType: "",
  });

  const addCommas = num => num?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const removeNonNumeric = num => num?.toString().replace(/[^0-9]/g, "");

  return (
    <>
      <style type="text/css">
        {`
                .modal {
                    background: #3335;
                }

                .modal-content {
                    width: 870px;
                    border-radius: 24px;
                }

                .modal-header {
                    align-items: center !important;
                }
          `}
      </style>

      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme="light"
      />

      <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header closeButton dir="rtl">
          <div className="w-100 d-flex align-items-start justify-content-between px-3">
            <div className={styles.title}>محاسبه آنلاین کمیسیون</div>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="container py-3 px-0 mt-2 text-end" dir="rtl">
            <div className="w-100 d-flex flex-column flex-md-row align-items-start justify-content-between gap-5">
              <div className="d-flex flex-column align-items-start pe-md-0 w-100">
                <h3 className={styles.form__header_title}>معامله مورد نظر خود را انتخاب کنید:</h3>
                {commissionData.sellOrRent === "sell" && (
                  <div className="w-100 d-flex align-items-center justify-content-start flex-wrap">
                    <RadioGroup
                      name="Radio"
                      row
                      aria-labelledby="demo-controlled-radio-buttons-group"
                      value={commissionData.commissionType}
                      onChange={changeHandler}>
                      <FormControlLabel className="mx-2" value="0" control={<Radio />} label="قانونی" />
                      <FormControlLabel className="mx-2" value="1" control={<Radio />} label="1%" />
                      <FormControlLabel className="mx-2" value="2" control={<Radio />} label="0.5%" />
                    </RadioGroup>
                  </div>
                )}
                <div className="w-100 d-flex flex-column flex-md-row align-items-center gap-2">
                  <button className={commissionData.sellOrRent === "sell" ? styles.form__btn_selected : styles.form__btn_unselected} onClick={clickHandler}>
                    خرید و فروش
                  </button>
                  <button className={commissionData.sellOrRent === "rent" ? styles.form__btn_selected : styles.form__btn_unselected} onClick={clickHandler}>
                    رهن و اجاره
                  </button>
                </div>
                <div className={`w-100 d-flex flex-column mt-4 position-relative ${styles.form__inputs_container}`}>
                  {commissionData.sellOrRent === "sell" ? (
                    <>
                      <div className="form-group position-relative mb-0">
                        <div className={`input-group mt-3 ${styles.form__input_container}`}>
                          <input
                            className={`${styles.form__input} form-control number-separator number-letter`}
                            placeholder="ثَمَنِ معامله (تومان - اجباری)"
                            type="text"
                            name="sellPrice"
                            onChange={changeHandler}
                            value={addCommas(removeNonNumeric(commissionData.sellPrice))}
                          />
                          <div className="input-group-prepend">
                            <span className={`input-group-text ${styles.input__group_text}`}>
                              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#FFFFFF" class="bi bi-house-check" viewBox="0 0 16 16">
                                <path d="M7.293 1.5a1 1 0 0 1 1.414 0L11 3.793V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v3.293l2.354 2.353a.5.5 0 0 1-.708.708L8 2.207l-5 5V13.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 2 13.5V8.207l-.646.647a.5.5 0 1 1-.708-.708z" />
                                <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.707l.547.547 1.17-1.951a.5.5 0 1 1 .858.514" />
                              </svg>
                            </span>
                          </div>
                        </div>
                      </div>
                      <span className={styles.number_farsi}>
                        {PersianNumberToString(parseInt(commissionData.sellPrice ? commissionData.sellPrice : 0))} تومان
                      </span>
                    </>
                  ) : (
                    <>
                      <div className="form-group position-relative mb-0">
                        <div className={`input-group mt-3 ${styles.form__input_container}`}>
                          <input
                            className={`${styles.form__input} form-control number-separator number-letter`}
                            placeholder="قیمت رهن ملک (تومان - اجباری)"
                            type="text"
                            name="mortgagePrice"
                            onChange={changeHandler}
                            value={addCommas(removeNonNumeric(commissionData.mortgagePrice))}
                          />
                          <div className="input-group-prepend">
                            <span className={`input-group-text ${styles.input__group_text}`}>
                              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#FFFFFF" class="bi bi-house-check" viewBox="0 0 16 16">
                                <path d="M7.293 1.5a1 1 0 0 1 1.414 0L11 3.793V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v3.293l2.354 2.353a.5.5 0 0 1-.708.708L8 2.207l-5 5V13.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 2 13.5V8.207l-.646.647a.5.5 0 1 1-.708-.708z" />
                                <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.707l.547.547 1.17-1.951a.5.5 0 1 1 .858.514" />
                              </svg>
                            </span>
                          </div>
                        </div>
                      </div>
                      <span className={styles.number_farsi}>
                        {PersianNumberToString(parseInt(commissionData.mortgagePrice ? commissionData.mortgagePrice : 0))} تومان
                      </span>
                      <div className="form-group position-relative mb-0">
                        <div className={`input-group mt-3 ${styles.form__input_container}`}>
                          <input
                            className={`${styles.form__input} form-control number-separator number-letter`}
                            placeholder="قیمت اجاره ملک (تومان - اجباری)"
                            type="text"
                            name="rentPrice"
                            onChange={changeHandler}
                            value={addCommas(removeNonNumeric(commissionData.rentPrice))}
                          />
                          <div className="input-group-prepend">
                            <span className={`input-group-text ${styles.input__group_text}`}>
                              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#FFFFFF" class="bi bi-house-check" viewBox="0 0 16 16">
                                <path d="M7.293 1.5a1 1 0 0 1 1.414 0L11 3.793V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v3.293l2.354 2.353a.5.5 0 0 1-.708.708L8 2.207l-5 5V13.5a.5.5 0 0 0 .5.5h4a.5.5 0 0 1 0 1h-4A1.5 1.5 0 0 1 2 13.5V8.207l-.646.647a.5.5 0 1 1-.708-.708z" />
                                <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.707l.547.547 1.17-1.951a.5.5 0 1 1 .858.514" />
                              </svg>
                            </span>
                          </div>
                        </div>
                      </div>
                      <span className={styles.number_farsi}>
                        {PersianNumberToString(parseInt(commissionData.rentPrice ? commissionData.rentPrice : 0))} تومان
                      </span>
                    </>
                  )}
                  <div className="d-flex flex-wrap justify-content-end w-100">
                    <button className={`w-100 mt-3 ${styles.form__btn}`} onClick={submitHandler}>
                      محاسبه کن
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-down" viewBox="0 0 16 16">
                        <path
                          fill-rule="evenodd"
                          d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1"
                        />
                      </svg>
                    </button>
                  </div>
                  <div className="form-group position-relative mb-0">
                    <div className={`input-group mt-3 ${styles.form__input_container}`}>
                      <input
                        readOnly
                        className={`${styles.form__input} form-control number-separator number-letter`}
                        placeholder={`مبلغ کمیسیون ${addCommas(removeNonNumeric(commissionData.commissionPrice))} تومان`}
                      />
                      <div className="input-group-prepend">
                        <span className={`input-group-text ${styles.input__group_text}`}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="#FFFFFF" class="bi bi-bank" viewBox="0 0 16 16">
                            <path d="m8 0 6.61 3h.89a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5H15v7a.5.5 0 0 1 .485.38l.5 2a.498.498 0 0 1-.485.62H.5a.498.498 0 0 1-.485-.62l.5-2A.5.5 0 0 1 1 13V6H.5a.5.5 0 0 1-.5-.5v-2A.5.5 0 0 1 .5 3h.89zM3.777 3h8.447L8 1zM2 6v7h1V6zm2 0v7h2.5V6zm3.5 0v7h1V6zm2 0v7H12V6zM13 6v7h1V6zm2-1V4H1v1zm-.39 9H1.39l-.25 1h13.72z" />
                          </svg>
                        </span>
                      </div>
                    </div>
                    <p className={styles.text__sm}>* مبلغ فوق، سهم هر طرف معامله از بابت کمیسیون معامله می باشد.</p>
                  </div>
                  <span className={styles.number_farsi}>
                    {PersianNumberToString(parseInt(commissionData.commissionPrice ? commissionData.commissionPrice : 0))} تومان
                  </span>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );

  function changeHandler(event) {
    if (event.target.name === "Radio") {
      setCommissionData(prev => {
        return { ...prev, commissionType: event.target.value };
      });
    } else {
      setCommissionData(prev => {
        return {
          ...prev,
          [event.target.name]: removeCommas(event.target.value),
        };
      });
    }
  }

  function clickHandler() {
    if (commissionData.sellOrRent === "sell") {
      setCommissionData(prev => {
        return {
          ...prev,
          sellOrRent: "rent",
          commissionPrice: "",
          sellPrice: "",
          rentPrice: "",
          mortgagePrice: "",
        };
      });
    } else {
      setCommissionData(prev => {
        return {
          ...prev,
          sellOrRent: "sell",
          commissionPrice: "",
          sellPrice: "",
          rentPrice: "",
          mortgagePrice: "",
        };
      });
    }
  }

  function submitHandler() {
    if (commissionData.sellOrRent === "sell") {
      if (commissionData.sellPrice != "") {
        notify("درحال محاسبه", "success");
      } else {
        notify(" لطفا ثَمَنِ معامله را وارد کنید ", "error");
      }
    } else {
      if (commissionData.rentPrice != "" || commissionData.mortgagePrice != "") {
        notify("درحال محاسبه", "success");
      } else {
        notify("لطفا قیمت رهن و اجاره را وارد کنید ", "error");
      }
    }
  }

  function notify(text, type) {
    if (type === "success") {
      toast.success(text, {
        position: "top-right",
        autoClose: 2500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      postHandler();
    } else {
      toast.error(text, {
        position: "top-right",
        autoClose: 2500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  }

  async function postHandler() {
    if (commissionData.sellOrRent === "sell") {
      try {
        const { sellPrice, commissionType } = commissionData;
        const apiData = await axios.get(`Consultant/SaleCommissionCalculationForConsultant?salePrice=${sellPrice}&saleCommissionType=${commissionType}`);
        setCommissionData(prev => {
          return { ...prev, commissionPrice: apiData.data.data };
        });
      } catch (error) {
        notify("خطای سرور", "error");
      }
    } else {
      try {
        const { mortgagePrice, rentPrice } = commissionData;
        const apiData = await axios.get(
          `Consultant/RentCommissionCalculationForConsultant?rentPrice=${rentPrice ? rentPrice : "0"}&mortgagePrice=${mortgagePrice ? mortgagePrice : "0"}`
        );
        setCommissionData(prev => {
          return { ...prev, commissionPrice: apiData.data.data };
        });
      } catch (error) {
        notify("خطای سرور", "error");
      }
    }
  }
}
